// // Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import React, { useState } from 'react'
import LytIssuerReserveTargetsEdit from './LytIssuerReserveTargetsEdit'
import { ReserveActionPlanClass } from './ReserveActionPlanClass'
import Box from '@mui/material/Box'
import LytIssuerReserveTargetsView from './LytIssuerReserveTargetsView'
import Typography from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'
import EditIcon from '@mui/icons-material/Edit'

export default function LytIssuerReserveTargetsViewOrEdit(props: {
  reserveActionPlanClass: ReserveActionPlanClass

  refreshCallback: () => void
}): React.ReactElement {
  const { reserveActionPlanClass } = props
  const [editMode, setEditMode] = useState(false)

  return (
    <Box>
      <Box>
        <Typography variant="h3">Reserve Targets</Typography>
        {!editMode && (
          <IconButton onClick={() => setEditMode(!editMode)}>
            <EditIcon />
          </IconButton>
        )}
      </Box>
      {editMode && (
        <LytIssuerReserveTargetsEdit
          reserveActionPlanClass={reserveActionPlanClass}
          refreshCallback={() => {
            setEditMode(false)
            props.refreshCallback()
          }}
        />
      )}
      {!editMode && <LytIssuerReserveTargetsView reserveActionPlanClass={reserveActionPlanClass} />}
    </Box>
  )
}
